import axios from "axios";

// Create an axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL, // API base URL
  // baseURL: "http://192.168.0.60:9000",  // API base URL
  // baseURL: "https://api.edio.in",  // API base URL
});

// Request interceptor to include the Authorization header and delay
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("Token"); // Get token from localStorage
    // Skip adding the token for login or register routes
    if (
      config.url.includes("/login") ||
      config.url.includes("/register") ||
      config.url.includes("/sendotp") ||
      config.url.includes("/pre-check")
      ||
      config.url.includes("/account-verify") ||
      config.url.includes("/reset-password")
    ) {
      return config; // No token needed for these routes
    }

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config; // Set the Authorization header
    } else {
      window.location.href = "/login"; // Redirect to login page if no token
      return Promise.reject("No token found");
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// export const api2 = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_URL,  // API base URL two
// });

export default api;
